import { ApiResponse } from "@/interfaces/ApiResponse";
import { LoginModel } from "@/models/LoginModel";
import { UserModel } from "@/models/User/UserModel";
import { apiService } from "../apiService";
import { apiConfig } from "../apiConfig";
import { notifyService } from "@/helpers/NotifyService";
import { ChangePasswordModel } from "@/models/User/ChangePasswordModel";

export function apiLogInUser(
  loginData: LoginModel
): Promise<ApiResponse<UserModel>> {
  return apiService
    .post<UserModel>(apiConfig.login, loginData)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
}

export function apiLogOutUser(): Promise<ApiResponse<null>> {
  const token = localStorage.getItem("accessToken");

  if (!token) {
    localStorage.removeItem("accessToken");

    return Promise.resolve({
      message: "No token found. Forced local logout.",
      data: null,
    });
  }

  return apiService
    .post<null>(apiConfig.logout, {}, token)
    .then((response) => {
      if (response.data) {
        localStorage.removeItem("accessToken");
      }
      return response;
    })
    .catch((error) => {
      return {
        message: error.message,
        data: null,
      } as ApiResponse<null>;
    });
}

export function apiChangePassword(
  changePasswordData: ChangePasswordModel
): Promise<ApiResponse<null>> {
  const token = localStorage.getItem("accessToken");

  if (!token) {
    return Promise.reject(new Error("No token found"));
  }

  return apiService
    .post<null>(apiConfig.changePassword, changePasswordData, token)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
}
